import saveToBraze from "../brazeUploader";
import { addMonitoringEventHandler } from "./bus";
import { getRouteId } from "@utils/meristemContext";
import { routeConstants } from "@utils/constants";

function transformAbandonedCartExperimentEvent(event) {
  const monitoredEvents = [
    "ClickedChoosePlanCTA",
    "OnWelcomeToNoom",
    "OnChooseTrialPrice",
    "OnCustomPlanPage",
    "OnEnterPaymentInfoPage",
  ];

  const monitoredRoutes = [routeConstants.emailMain];

  const newEventName = "abandonedCartExperimentEvent";

  if (
    !monitoredEvents.includes(event.eventName) ||
    !monitoredRoutes.includes(getRouteId())
  ) {
    return null;
  }

  return {
    event_name: newEventName,
    event_data: {
      routeId: getRouteId(),
      ...event.properties,
      type: event.eventName,
    },
  };
}

addMonitoringEventHandler((event) => {
  if (event.type === "track") {
    const newEvent = transformAbandonedCartExperimentEvent(event);
    // eslint-disable-next-line no-unused-expressions
    newEvent && saveToBraze({ event: newEvent });
  }
});
